import { createFileRoute } from "@tanstack/react-router";
import { DeptContentForm } from "@/components/dept-content/DeptContentForm";
import { FACILITIES } from "@/lib/deptContent";

export const Route = createFileRoute("/_app/departments/facilities/new")({
  component: () => <DeptContentForm cfg={FACILITIES} />,
});
